import React from "react";
import FireImage from "../images/firewood.jpg"

const Home = () => {
    return (
        <div>
            <h1>The Best Firewood In Town</h1>
            <p> Brookline Firewood started in 1995 and is a family run business. We are excited, educated, and experienced about what we do. Our loggers are state certified which mean we work with the environment, not against the environment. We run our own log trucks so we know exactly where the lumber comes from and how it was harvested. This gives us the ability to make a decision as to what we keep, process and sell, and what is sent to the mills.
                The Firewood products you order are the products you will receive from us. There are many people out there that say you will get Oak or Maple, etc. and you receive poplar or pine. We do not misrepresent our products or our business.
            </p>
            <img src={FireImage} class="img-fluid" id="fire" />
        </div >


    )
};
export default Home;